import { render, staticRenderFns } from "./ctf-rich-text-heading.vue?vue&type=template&id=2abeab72&"
import script from "./ctf-rich-text-heading.vue?vue&type=script&lang=js&"
export * from "./ctf-rich-text-heading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports